import { EXTERNAL_APP_URI } from '../../common/uri/property-uri.constants';
export interface IKanbanState {
    kanbanUrl?: string
    kanbanAuthentication?: any
}

export class KanbanState implements IKanbanState {
    kanbanUrl: string;
    kanbanAuthentication: any;

    constructor(options?: IKanbanState) {
        this.kanbanUrl = options?.kanbanUrl || EXTERNAL_APP_URI.KANBAN_APP
        this.kanbanAuthentication = options?.kanbanAuthentication || null
    }
}